/**
 * Who owns the screen when two things want it at once.
 *
 * The dashboard opens a widget video by itself on a first visit, and the coin
 * popups (welcome bonus, daily bonus, post published) arrive from a network
 * call — so which lands first is a race, and the video was taking the screen out
 * from under a popup the member was still reading.
 *
 * The rule, one place: a blocking popup wins, and anything that wants to take
 * over the screen waits until the last one has been dismissed. Deliberately a
 * counter rather than a boolean — two popups can overlap in principle, and the
 * video must wait for BOTH, not just the first to close.
 */
let openCount = 0;
const listeners = new Set();

export const isBlockingPopupOpen = () => openCount > 0;

export const markBlockingPopupOpen = () => {
  openCount += 1;
};

export const markBlockingPopupClosed = () => {
  openCount = Math.max(0, openCount - 1);
  if (openCount === 0) {
    // Copy first: a listener may unsubscribe itself while we iterate.
    [...listeners].forEach((listener) => listener());
  }
};

/** Runs `listener` once the screen is free. Returns an unsubscribe function. */
export const onBlockingPopupsCleared = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
